import { Component } from '@angular/core';

@Component({
  selector: 'app-deeproots-eula',
  standalone: true,
  imports: [],
  templateUrl: './deeproots-eula.component.html',
  styleUrl: './deeproots-eula.component.scss',
})
export class DeeprootsEulaComponent {}
